import { defineComponent as _defineComponent } from 'vue'
import mapboxgl from 'mapbox-gl'
import GeoJsonSource from '../mapbox/GeoJsonSource.vue'
import LayerGroup from '../mapbox/LayerGroup.vue'
import { computed } from 'vue'
import { UnitNumber } from '@/models/unit_number'
import { resourcePinStyle } from './styles/resource-pin'
import { useResourceLocationQuery } from '@/api/unit_numbers'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourcesSelectedLayer',
  props: {
    layerId: null,
    sourceId: null,
    showResource: null,
    hideLayer: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  layerId: string
  sourceId: string
  showResource: UnitNumber | null
  hideLayer?: boolean
}



const resourceId = computed(() => props.showResource?.id)
const { data: latestLocation } = useResourceLocationQuery(resourceId)

const data = computed(() => {
  const resource = props.showResource
  const features =
    resource && latestLocation.value
      ? [
          {
            id: resource?.id?.toString(),
            type: 'Feature',
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            geometry: {
              type: 'Point',
              coordinates: [
                latestLocation.value.longitude,
                latestLocation.value.latitude,
              ],
            },
            properties: {
              Id: resource.id,
              Name: resource.name,
              Status: resourceStatusToString(resource.status),
              LastLocationHeading: latestLocation.value.heading,
              OnDuty: resource.operator?.onDuty,
            },
          },
        ]
      : []

  return {
    type: 'FeatureCollection',
    features,
  }
})

const layers: mapboxgl.SymbolLayer[] = [
  {
    id: props.layerId,
    type: 'symbol',
    layout: {
      ...resourcePinStyle.layout,
      'symbol-sort-key': 0,
      'icon-size': 1.5,
      'icon-allow-overlap': false,
      'icon-optional': false,
      'text-radial-offset': 2,
      'text-allow-overlap': true,
      'text-optional': false,
      'text-size': {
        stops: [
          [15, 11],
          [15.5, 12],
          [17, 14],
        ],
      },
    },
    paint: {
      ...resourcePinStyle.paint,
      'text-opacity': 1,
    },
  },
]

function resourceStatusToString(status: number) {
  if (status === 0) {
    return 'Offline'
  } else if (status === 1) {
    return 'Standby'
  } else {
    return 'Active'
  }
}

return { __sfc: true,props, resourceId, latestLocation, data, layers, resourceStatusToString, GeoJsonSource, LayerGroup }
}

})